import { useTranslation } from "react-i18next";

export default function CTABanner() {
  const { t } = useTranslation("schuifpui-reparatie");

  return (
    <section className="bg-brand-blue py-20 md:py-[100px] w-full text-center">
      <div className="max-w-[1400px] mx-auto px-4 md:px-10">
        <h2 className="font-geist font-bold text-3xl md:text-[48px] text-white mb-8">
          {t("ctaBanner.h2")}
        </h2>
        <a
          href="tel:+31407987470"
          className="inline-flex items-center gap-2 font-geist font-bold text-base md:text-lg bg-brand-yellow text-brand-text px-8 md:px-9 py-4 md:py-5 rounded-full hover:bg-white transition-colors whitespace-nowrap"
        >
          <i className="ri-phone-line w-5 h-5 flex items-center justify-center"></i>
          {t("ctaBanner.cta")}
        </a>
      </div>
    </section>
  );
}